import { createWebHistory, createRouter } from "vue-router";
import routes from "./routes";
import authHelper from "@/helpers/auth-helper";

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0, left: 0 };
  },
});

let isLocked = false;

// Guard principal
router.beforeEach((to, from, next) => {
  const islogged = authHelper.isLogged();

  // Vérification d'authentification normale
  if ((to.matched.some((route) => route.meta.authRequired) || to.matched.some((route) => route.meta.requiresAuth)) && !islogged) {

  console.log("Navigation vers:", to.fullPath, "Token présent:", !!islogged, "isLocked:", isLocked);
  authHelper.logout();
    return next({ name: "login", query: { redirectFrom: to.fullPath } });
  }

  // Vérification super-admin
  if (to.matched.some((route) => route.meta.superAdmin)) {
    const accessType = authHelper.getAccessType();
    if (accessType !== 'S') {
      return next({ name: "home" });
    }
  }

  // Vérification des permissions spécifiques
  const requiredPermission = to.matched.find((route) => route.meta.permission);
  if (requiredPermission) {
    const userPermissions = authHelper.getPermissions();
    let permsArray = [];
    try {
      permsArray = JSON.parse(userPermissions);
    } catch {
      permsArray = [];
    }
    if (!permsArray.includes(requiredPermission.meta.permission)) {
      return next({ name: "home" });
    }
  }

  next();
});

// Empêcher le retour en arrière sur certaines routes
const noBackRoutes = ['/login', '/logout', '/reset-password', '/', '/Forgot-password'];

router.afterEach((to) => {
  // Si on navigue vers une route où on ne veut pas pouvoir revenir en arrière
  if (noBackRoutes.includes(to.path)) {
    // Remplace l'entrée actuelle dans l'historique
    window.history.replaceState(null, '', window.location.href);
    
    // Empêche le retour en arrière en ajoutant une entrée supplémentaire
    window.history.pushState(null, '', window.location.href);
    
    console.log(`Navigation verrouillée pour: ${to.path}`);
  }
});

// Gérer l'événement popstate (bouton retour)
window.addEventListener('popstate', () => { // ← SUPPRIMER le paramètre 'event' ici
  const currentPath = window.location.pathname;
  
  // Si on est sur une route où on ne veut pas de retour en arrière
  if (noBackRoutes.includes(currentPath)) {
    console.log("Retour en arrière bloqué sur:", currentPath);
    
    // Empêcher le retour et rester sur la page actuelle
    window.history.pushState(null, '', window.location.href);
    
    // Optionnel : Rediriger vers une page spécifique
    // router.replace('/');
  }
});

// Empêcher l'actualisation avec confirmation
window.addEventListener('beforeunload', (event) => {
  if (isLocked) {
    event.preventDefault();
    event.returnValue = 'Votre session est verrouillée. Déverrouillez-la avant de quitter.';
    return 'Votre session est verrouillée. Déverrouillez-la avant de quitter.';
  }
});

// Export fonction unlock
export function unlockScreen() {
  isLocked = false;
}

// Export fonction lock
export function lockScreen() {
  isLocked = true;
}

// Export fonction pour vérifier le statut
export function isScreenLocked() {
  return isLocked;
}

export default router;